import { chakraComponents, Props as SelectProps } from 'chakra-react-select';
import { Select } from './Select';

export type { SelectProps };
export { Select, chakraComponents };
export * from './select.config';
